/**
 * Sentinel node id used by the entity diagram and entity map to open the bulk
 * AI tile-notes panel (EntityTileNotesSummaryPanel) in their summary-panel
 * slot. It is not a real graph node — each diagram's NodeSummaryPanel special-
 * cases this id, mirroring the waterfall's TILE_NOTES_SENTINEL.
 */
export const TILE_NOTES_BULK_PANEL_ID = '__ENTITY_TILE_NOTES_BULK__';
